import React, { useEffect, useState } from "react";
import { Grid, Card, CardContent, Snackbar, Alert, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import * as descuentoCatalogoService from "../../services/descuentoCatalogoService";
import * as catalogoService from "../../services/catalogoService";
import MantenimientoForm from "../../components/common/MantenimientoForm";
import { useParams, useNavigate } from "react-router-dom";

const Edit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [entity, setEntity] = useState({ id: 0, codigo: "", descripcion: "", idTipoDescuento: 316, valor: 0, idEstado: 2 });
    const [listTipos, setListTipos] = useState([]);
    const [openMessage, setOpenMessage] = useState(false);
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });

    useEffect(() => {
        (async () => {
            if (id && id !== "0") {
                const data = await descuentoCatalogoService.getDescuentoCatalogo(id).catch(() => null);
                if (data) setEntity(data);
            }
        })();
        (async () => {
            const data = await catalogoService.getCatalogosByPadre(315).catch(() => []);
            setListTipos(data || []);
        })();
    }, [id]);

    const save = async () => {
        try {
            await descuentoCatalogoService.addUpdateDescuentoCatalogo(entity);
            setPropsMessage({ severity: "success", message: "Guardado con exito" });
            setOpenMessage(true);
            navigate("/descuentocatalogo");
        } catch (e) {
            setPropsMessage({ severity: "error", message: "Error al guardar" });
            setOpenMessage(true);
        }
    };

    return (
        <Grid container>
            <MantenimientoForm title={(id === "0" ? "Nuevo" : "Editar") + " Descuento Catalogo"} backTo="/descuentocatalogo" onSave={save}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={4}>
                                        <TextField label="Codigo" fullWidth size="small" value={entity.codigo || ""} onChange={(e) => setEntity({...entity, codigo: e.target.value})} />
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <TextField label="Descripcion" fullWidth size="small" value={entity.descripcion || ""} onChange={(e) => setEntity({...entity, descripcion: e.target.value})} />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Tipo descuento</InputLabel>
                                            <Select value={entity.idTipoDescuento} onChange={(e) => setEntity({...entity, idTipoDescuento: e.target.value})} label="Tipo descuento">
                                                {(listTipos || []).map((t) => <MenuItem key={t.id} value={t.id}>{t.descripcion}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField type="number" label="Valor" fullWidth size="small" value={entity.valor || 0} onChange={(e) => setEntity({...entity, valor: parseFloat(e.target.value) || 0})} />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </MantenimientoForm>
            <Snackbar open={openMessage} autoHideDuration={4000} onClose={() => setOpenMessage(false)}>
                <Alert severity={propsMessage.severity}>{propsMessage.message}</Alert>
            </Snackbar>
        </Grid>
    );
};

export default Edit;